import Boot from "@/main";
import ConfiguracaoWhatsAppSituacao from "@/models/enum/configuracaoWhatsAppSituacao";
import TipoTemplateWhatsApp from "@/models/enum/TiposTemplateWhatsApp";

import ConfiguracaoWhatsAppService from "../atendimentos/configuracaoWhatsAppService";
import WhatsAppService from "../atendimentos/whatsAppService";
import TemplateWhatsAppService from "../templateWhatsAppService";

export default class WhatsAppUtilsService {
    configuracaoWhatsAppService: ConfiguracaoWhatsAppService;
    templateWhatsAppService: TemplateWhatsAppService;
    whatsAppService: WhatsAppService;

    constructor() {
        this.configuracaoWhatsAppService = new ConfiguracaoWhatsAppService();
        this.templateWhatsAppService = new TemplateWhatsAppService();
        this.whatsAppService = new WhatsAppService();
    }

    async showMensagemWhats(telefoneDestino: string, msg: string, vendaId?: number) {
        const template = await this.templateWhatsAppService
            .getByTipo(TipoTemplateWhatsApp.CompartilharOrcamento, vendaId)
            .resolveWithText();

        if (!template && !msg) {
            return Boot.$showWarning(Boot.$t("__.ts.atencao"), Boot.$t("__.ts.nenhumTemplateCadas"));
        } else if (template && !msg) {
            msg = template;
        }

        const statusIntegracao = await this.configuracaoWhatsAppService.getStatusIntegracao();
        const integracaoWhatsAppProntoParaUso = statusIntegracao == ConfiguracaoWhatsAppSituacao.ProntoParaUso;

        const textoBotaoEnviar = integracaoWhatsAppProntoParaUso ? "Enviar Automaticamente" : "Enviar";
        const acaoEnviar = (numero, mensagem) =>
            integracaoWhatsAppProntoParaUso
                ? this.enviarMensagemIntegracao(numero, mensagem)
                : this.abrirWhatsWeb(numero, mensagem);

        try {
            const response = await Boot.$showAlert({
                title: Boot.$t("__.ts.enviarOrca") as string,
                text: Boot.$t("__.ts.enviarMsgOrcaCliente") as string,
                html: `
                <label>Telefone:</label>
                <input id="swal-input-tel" class="swal2-input" value="${telefoneDestino ?? ""}">
                <textarea style="width: 95%; height: 300px; margin: 10px;" id="swal-textarea" class="swal2-textarea">${msg
                    .replace('"', "")
                    .replace('"', "")}</textarea>
                <button id="copy-button" class="swal2-confirm swal2-styled" style="width: 42%; margin-top: 0px; margin-bottom: 0px; background-color: #3ba0b1">Copiar</button>
                `,
                showCancelButton: true,
                confirmButtonText: textoBotaoEnviar,
                preConfirm: () => {
                    return {
                        telefone: (document.getElementById("swal-input-tel") as HTMLInputElement).value,
                        mensagem: (document.getElementsByClassName("swal2-textarea")[0] as HTMLTextAreaElement).value,
                    };
                },
                didOpen: () => {
                    const copyButton = document.getElementById("copy-button");
                    copyButton.addEventListener("click", event => {
                        event.preventDefault();
                        const textarea = document.getElementById("swal-textarea") as HTMLTextAreaElement;
                        textarea.select();
                        document.execCommand("copy");
                    });
                },
            });

            if (response.isConfirmed) {
                const celular = response.value.telefone.replace(/\D/g, "");
                acaoEnviar(celular, response.value.mensagem);
            }
        } catch {}
    }

    private abrirWhatsWeb(celular, mensagem) {
        const url = "https://api.whatsapp.com/send?phone=55" + encodeURI(celular) + "&text=" + encodeURI(mensagem);
        const win = window.open(url);
        win.focus();
    }

    public async enviarMensagemIntegracao(numeroDestino: string, mensagem: string): Promise<void> {
        const sucesso = await this.whatsAppService.enviarMensagemTexto(numeroDestino, mensagem);

        if (sucesso) {
            Boot.$notifySuccess("Mensagem enviada com sucesso!");
        }
    }
}
